import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to check if a user already exists with the given email
 * @param email - The email to check
 * @returns Object with userExists boolean and isLoading state
 */
export const useCheckUserExists = (email: string | null | undefined) => {
  const [userExists, setUserExists] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      if (!email) {
        setUserExists(false);
        return;
      }

      setIsLoading(true);
      try {
        // Use RPC function to check user existence
        // This bypasses RLS policies that prevent TDs from seeing travelers
        // who don't have TRs assigned yet
        const { data, error } = await supabase
          .rpc('check_user_exists_by_email', {
            p_email: email.toLowerCase().trim()
          });

        if (error) {
          console.error('Error checking user existence:', error);
          setUserExists(false);
        } else {
          setUserExists(!!data);
        }
      } catch (err) {
        console.error('Error checking user existence:', err);
        setUserExists(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkUser();
  }, [email]);

  return { userExists, isLoading };
};
